<div [className]="selectClasses.header" #header>
  <input
    type="text"
    tabindex="0"
    placeholder="Search..."
    [className]="selectClasses.search"
    #query
  />
</div>
<div
  (scroll)="onOptionsContainerScroll($event)"
  [className]="selectClasses.scrollContainer"
  #scrollContainer
>
  <ng-container *ngIf="!parent.loadingOptions">
    <ta-transfer-option
      *ngFor="let option of options"
      [option]="option"
      [disabled]="disabled || (disallowedOptions?.includes(option.code) && disableDisallowedOptions)"
      [disallowed]="disallowedOptions?.includes(option.code)"
    ></ta-transfer-option>
  </ng-container>
  <div
    *ngIf="showLoadingIndicator && parent.loadingOptions"
    [className]="selectClasses.loadingNotice"
  >
    <ta-icon icon="circle-notch" spin></ta-icon>
  </div>
  <div
    *ngIf="showLoadingIndicator && noOptionsAvailable"
    [className]="selectClasses.loadingNotice"
  >
    <span [className]="selectClasses.label">No options available</span>
  </div>
</div>
